import React from "react";
import { isValidRegex } from "@sscs/utils";
import styles from "./highlightMatch.module.scss";
const HighlightMatch = ({ value, regex, }) => {
    const data = [];
    let previous = 0;
    if (!value || !regex)
        return React.createElement("span", null, value);
    if (value === regex) {
        data.push(React.createElement("span", { key: previous, className: styles.highlight }, value));
        previous = value.length;
    }
    else if (regex && isValidRegex(regex)) {
        const matches = value.matchAll(new RegExp(regex, "ig"));
        for (const match of matches) {
            if (match.index !== undefined) {
                data.push(JSON.stringify(value.substring(previous, match.index)).slice(1, -1));
                data.push(React.createElement("span", { key: previous, className: styles.highlight }, JSON.stringify(match[0]).slice(1, -1)));
                previous = match.index + match[0].length;
            }
        }
    }
    if (previous < value.length) {
        data.push(JSON.stringify(value.substring(previous)).slice(1, -1));
    }
    return React.createElement("span", null, data);
};
export default HighlightMatch;
//# sourceMappingURL=HighlightMatch.js.map